import { supabase } from '../supabaseClient';

/* Accès aux données « boamp_documents ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function insertTenderDocuments(file, idweb, storagePath, texte, type) {
  return supabase
    .from('boamp_documents')
    .insert({
      idweb,
      type,
      filename: file.name,
      storage_path: storagePath,
      texte_extrait: texte,
      source: 'manuel',
    })
    .select()
    .single();
}

export function deleteTenderDocument(doc) {
  return supabase.from('boamp_documents').delete().eq('id', doc.id);
}
